import { Injectable } from '@angular/core';
import remove from 'lodash/remove';

export interface IBreadcrumCustomTag {
  color?: string;
  border?: string;
  text: string;
}
export interface IBreadcrumbPart {
  title: string;
  commands?: string | any[];
  truncateText?: boolean;
  isBetaTag?: boolean;
  customTag?: IBreadcrumCustomTag;
}
export type IBreadcrumb = IBreadcrumbPart[];
@Injectable()
export class Breadcrumb {
  public components: any[] = [];

  public registerComponent(component): void {
    if (this.components.indexOf(component) < 0) this.components.push(component);
  }

  public unregisterComponent(component): void {
    remove(this.components, comp => comp === component);
  }

  /**
   * This method takes in a breadcrumb object as per IBreadcrumb interface to set breadcrumbs.
   * It also takes a title, subtitle and subtitle style for mobile view which is visible only on the responsive page-header
   * component for now
   */
  public set(
      breadcrumb: IBreadcrumb,
      titleForMobileView: string = null,
      subTitleForMobileView: string = null,
      subTitleForMobileStyle: Partial<CSSStyleDeclaration> = {},
    ): void {
    this.components.forEach(component =>
      component.update(breadcrumb, titleForMobileView, subTitleForMobileView, subTitleForMobileStyle),
    );
  }

  public clear(): void {
    this.components.forEach(component => component.update([]));
  }
}
